
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resident/application/get-started",
      function () {
        return require("private-next-pages/resident/application/get-started/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resident/application/get-started"])
      });
    }
  